import { render, staticRenderFns } from "./DashboardLayoutMarketAdmin.vue?vue&type=template&id=165e8214&"
import script from "./DashboardLayoutMarketAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutMarketAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutMarketAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports